import { React, useState } from 'react';
import { useSelector } from 'react-redux';
import { Typography, TextField, Button, DialogActions } from '@mui/material';
import DraggableModal from '../../components/DraggableModal';
import { selectors as growerSelectors } from '../../store/dux/grower-dux';

export function ReassignFields(props) {
  const { fieldsToReassign, close, save } = props;
  const growerId = useSelector(growerSelectors.selectedId);
  const [isValid, setIsValid] = useState(true);
  const [doNotAllowSave, setDoNotAllowSave] = useState(true);
  const [newGrowerId, setNewGrowerId] = useState('');

  const handleChange = (event) => {
    const inputValue = event.target.value;
    setNewGrowerId(inputValue);
    const guidPattern =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    setIsValid(guidPattern.test(inputValue));
    setDoNotAllowSave(!guidPattern.test(inputValue));
  };

  return (
    <DraggableModal
      handleClose={close}
      title="Reassign Fields"
      noMinHeight={true}
    >
      <Typography variant="body1">From Operation</Typography>
      <Typography variant="caption">
        Which Operation are you moving from
      </Typography>
      <TextField
        variant="outlined"
        margin="normal"
        label="From ID"
        fullWidth
        disabled
        value={growerId}
      />
      <Typography variant="body1" sx={{ mt: 2 }}>
        To Operation
      </Typography>
      <Typography variant="caption">
        Which Operation are you moving to
      </Typography>
      <TextField
        variant="outlined"
        margin="normal"
        label="To ID"
        value={newGrowerId}
        error={!isValid}
        helperText={!isValid ? 'Invalid GUID' : ''}
        fullWidth
        onChange={handleChange}
      />
      <DialogActions>
        <Button onClick={close} variant="contained" color="inherit">
          Close
        </Button>
        <Button
          onClick={(e) => {
            save(newGrowerId, fieldsToReassign);
            close(e);
          }}
          color="primary"
          variant="contained"
          disabled={doNotAllowSave}
        >
          Save
        </Button>
      </DialogActions>
    </DraggableModal>
  );
}
